import React from 'react';
import {FaGear} from "react-icons/fa6";
import {FaEdit, FaPlus, FaMap} from "react-icons/fa";
import {useEdgeBuilder} from "../../association-network-context.jsx";

const Menu = ({setPanelOpened}) => {
    const {viewMode, setViewMode} = useEdgeBuilder();
    const isMap = viewMode === "map";

    const openPanel = (panel) => {
        setViewMode("flow");
        setPanelOpened(panel);
    };

    const toggleMap = () => {
        if (isMap) {
            setViewMode("flow");
            return;
        }
        setPanelOpened(null);
        setViewMode("map");
    };

    return (
        <div className={"bg-white rounded-[5px] shadow-[0_1px_4px_-1px_#0000004d]"}>
            <div title={"Editar nome"} onClick={() => openPanel("init")} className={"p-3 cursor-pointer hover:bg-[#d3d3d3]"}>
                <FaEdit size={20} color={"#676a6c"}/>
            </div>
            <div title={"Adicionar elemento"} onClick={() => openPanel("search")} className={"p-3 cursor-pointer hover:bg-[#d3d3d3]"}>
                <FaPlus size={20} color={"#676a6c"}/>
            </div>
            <div title="Configurações de visualização" onClick={() => openPanel("config")} className={"p-3 cursor-pointer hover:bg-[#d3d3d3]"}>
                <FaGear size={20} color={"#676a6c"}/>
            </div>
            <div title={isMap ? "Fechar visualização no mapa" : "Abrir visualização de mapa"} onClick={toggleMap}
                 className={`p-3 cursor-pointer hover:bg-[#d3d3d3] ${isMap ? "bg-[#d3d3d3]" : ""}`}>
                <FaMap size={20} color={isMap ? "#063A6C" : "#676a6c"}/>
            </div>
        </div>
    );
};

export default Menu;
